import { HttpStatusCode } from "axios"
import { getAuthedApi } from "../api/api"

interface ValidationFailure {
    propertyName: string,
    errorMessage: string,
    errorCode: string,
}

interface InitiativeFollowRequest {
    jiraId: string,
    title: string,
    roadmapLink: string,
    isFollowed: boolean
}

export interface RoadmapFollowResponse {
    jiraId: string,
    isFollowed: boolean
    validationErrors: ValidationFailure[],
}

export const addFollow = async (jiraId: string) => {
    const authedApi = await getAuthedApi()
    const response = await authedApi.post(`api/v2.0/roadmap/jira-id/${jiraId}/follow`)
    return response.status == HttpStatusCode.Created
}

export const removeFollow = async (jiraId: string) => {
    const authedApi = await getAuthedApi()
    const response = await authedApi.delete(`api/v2.0/roadmap/jira-id/${jiraId}/follow`)
    return response.status == HttpStatusCode.NoContent
}